import { useFavoritesApi } from './api/useFavoritesApi.ts';

export const useExperienceFavorites = defineStore('favorites', () => {
  const { getFavoriteIds } = useFavoritesApi();
  const favoriteIds = ref<Set<number>>(new Set());

  const loadFavorites = async () => {
    try {
      const ids = await getFavoriteIds();
      favoriteIds.value = new Set(ids);
    } catch (e) {
      console.error('Не удалось загрузить избранные:', e);
    }
  };

  const isFavorite = (id: number): boolean => {
    return favoriteIds.value.has(id);
  };

  return {
    favoriteIds,
    loadFavorites,
    isFavorite,
  };
});
